import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.678 8.442c0 .662.021.375.043 2.426.043 4.722-2.32 4.28-2.32 2.427 0-1.963 6.316-.882 6.316-.882"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M3 5h10.635c3.953 0 7.154 3.287 7.154 7.347s-3.2 7.346-7.154 7.346c-3.846 0-6.983-3.11-7.154-7.038H5.17"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.523 10.67H4.29M6.523 8.728H3.644M6.523 6.787H3"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const FastIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
